import { render, staticRenderFns } from "./PurchaseInvoiceMailModalContent.vue?vue&type=template&id=3e236f57"
import script from "./PurchaseInvoiceMailModalContent.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports